// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"WelcomeScreen_mainContainer__1P_iD"};